import type { ScoreType } from '~/types/aso'

export const COLORS: Record<ScoreType, { [key: number]: string }> = {
  competitiveness: {
    0: '#CA3423',
    1: '#CA3423',
    2: '#FFA500',
    3: '#DED844',
    4: '#27C165',
    5: '#06703D',
  },
  completion: {
    0: '#e82762',
    1: '#fca03d',
    100: '#34c396',
  },
  confidence: {
    1: '#E82762',
    2: '#FCA03D',
    3: '#34C396',
  },
  health: {
    10: '#CA3423',
    100: '#06703D',
    20: '#FFA500',
    30: '#FDBF4E',
    40: '#DEBC44',
    50: '#DED844',
    60: '#ADDE44',
    70: '#56C030',
    80: '#43E47A',
    90: '#27C165',
  },
  keywords: {
    0: '#CA3423',
    10: '#CA3423',
    100: '#06703D',
    20: '#FFA500',
    30: '#FDBF4E',
    40: '#DEBC44',
    50: '#DED844',
    60: '#ADDE44',
    70: '#56C030',
    80: '#43E47A',
    90: '#27C165',
  },
  opportunity: {
    10: '#CA3423',
    100: '#06703D',
    20: '#FFA500',
    30: '#FDBF4E',
    40: '#DEBC44',
    50: '#DED844',
    60: '#ADDE44',
    70: '#56C030',
    80: '#43E47A',
    90: '#27C165',
  },
  popularity: {
    0: '#CA3423',
    10: '#CA3423',
    100: '#06703D',
    20: '#FFA500',
    30: '#DED844',
    40: '#56C030',
    50: '#43E47A',
    60: '#27C165',
    70: '#27C165',
    80: '#06703D',
    90: '#06703D',
  },
  subtitle: {
    0: '#CA3423',
    10: '#CA3423',
    20: '#FFA500',
    30: '#06703D',
  },
  title: {
    0: '#CA3423',
    10: '#CA3423',
    20: '#FFA500',
    30: '#06703D',
  },
}
